import React from "react"
import moment from "moment"
const TeamsScreenTableContainer = ({ el, selectToggle, compactView }) => {
  return (
    <>
      <tr>
        <th scope="col" className="text-uppercase">
          Name
        </th>
        <td>{!selectToggle ? el.userName : el.displayName}</td>
      </tr>
      <tr>
        <th scope="row" className="text-uppercase">
          In
        </th>
        <td>{moment(el?.startTime).format("HH:mm:ss")}</td>
      </tr>
      <tr>
        <th scope="row" className="text-uppercase">
          Out
        </th>
        <td>{moment(el?.endTime).format("HH:mm:ss")}</td>
      </tr>
      <tr>
        <th scope="row" className="text-uppercase">
          Hours
        </th>
        <td style={{ color: "orange" }}>{el?.totalHours}</td>
      </tr>
      <tr>
        <th scope="row" className="text-uppercase">
          Active
        </th>
        <td>{el?.activeHours}</td>
      </tr>
      {compactView == 2 && (
        <tr>
          <th scope="row" className="text-uppercase">
            Private
          </th>
          <td>{el?.privateHours}</td>
        </tr>
      )}

      <tr>
        <th scope="row" className="text-uppercase">
          Break
        </th>
        <td>{el?.breakHours}</td>
      </tr>

      {compactView == 2 && (
        <tr>
          <th scope="row" className="text-uppercase">
            Idle
          </th>
          <td>{el?.idleHours}</td>
        </tr>
      )}
      <tr>
        <th scope="row" className="text-uppercase">
          On Evaluation
        </th>
        <td>{el?.onEvaluationHours}</td>
      </tr>
    </>
  )
}

export default TeamsScreenTableContainer
